module.exports = __webpack_public_path__ + "img/x.4f2bbb13.svg";